import { render, staticRenderFns } from "./modal-mover-item-agrupamento.vue?vue&type=template&id=e988f3f2&scoped=true"
import script from "./modal-mover-item-agrupamento.vue?vue&type=script&lang=ts"
export * from "./modal-mover-item-agrupamento.vue?vue&type=script&lang=ts"
import style0 from "./modal-mover-item-agrupamento.vue?vue&type=style&index=0&id=e988f3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e988f3f2",
  null
  
)

export default component.exports